import { AsYouType, E164Number } from 'libphonenumber-js'

export const formatPhoneNumber = (value: string | null): E164Number | null => {
  if (!value) return value
  const onlyDigitsAndPlus = value.replace(/[^0-9+]/g, '')
  const formatted = new AsYouType().input(onlyDigitsAndPlus)

  return formatted
}
